module.exports = __webpack_public_path__ + "img/elckerlijc.1.99fbda5d.jpg";